import PropTypes from 'prop-types'

import Text from './Text'

const Content = ({ children, text, type }) => (
  <div className={`toast-content ${type}`}>
    <Text text={text} />
    {children}
  </div>
)

export default Content

Content.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]),
  text: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired
}
